/* Gebert & Weschka — Warenkorb-Prüfung für Zuschnitte.
   ------------------------------------------------------------------------
   Der Zuschnitt-Rechner legt Teile UND eine passende Versandzeile in den
   Warenkorb. Danach kann der Kunde dort aber weiterarbeiten: Menge ändern,
   eine Länge löschen, die Versandzeile selbst entfernen. Dann passt der Satz
   nicht mehr zu den Längen — und zwar in beide Richtungen:

     • Er nimmt das 2-m-Teil heraus und zahlt weiter 24,90 € statt 9,90 €.
       Das ist der häufigere Fall, passiert versehentlich, und der Kunde
       zahlt ZU VIEL. Das darf nicht sein.
     • Er löscht die Versandzeile und zahlt gar keinen Versand.

   Diese Datei repariert beides beim Öffnen des Warenkorbs. Sie ist damit
   Bequemlichkeit und Ehrlichkeit, aber KEINE Sperre — sie läuft im Browser
   des Kunden. Wer den Warenkorb per API manipuliert und direkt zur Kasse
   springt, kommt daran vorbei. Dicht wird das erst mit der
   Validierungs-Function auf Shopifys Servern (_server/zuschnitt/validierung/).

   Läuft nur, wenn window.GW_CUT_CART.dienst gesetzt ist — ohne Dienst gibt
   es auch keine Versandzeilen. */
(function () {
  "use strict";

  function adresse() {
    var k = window.GW_CUT_CART || {};
    return String(k.dienst || "").replace(/\/+$/, "");
  }

  /* Unsere eigene Versandzeile erkennen. Die versteckte Eigenschaft ist das
     verlässliche Merkmal; der Titelvergleich ist nur der Rückfall für
     Zeilen, die noch von einer älteren Fassung im Warenkorb liegen. */
  function istVersand(zeile) {
    var e = zeile.properties || {};
    if (e._gw_versand === "1" || e._gw_versand === 1) return true;
    return /^Versand\s+·/.test(zeile.product_title || "")
        || /^Versand\s+·/.test(zeile.title || "");
  }

  function titelVon(zeile) {
    /* product_title + variant_title ist genau der Text, aus dem der Dienst
       die Länge liest. options_with_values fällt bei Produkten ohne
       Varianten weg, deshalb beides zusammensetzen. */
    return [zeile.product_title || "", zeile.variant_title || "",
            zeile.title || ""].join(" · ");
  }

  /* Waehrend wir selbst am Warenkorb schrauben, darf der Beobachter unten
     nicht erneut anspringen -- sonst reparieren wir uns im Kreis. */
  var eigeneAenderung = false;

  function post(pfad, koerper) {
    return fetch(pfad, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(koerper)
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }


  /* ── Frische Varianten brauchen einen Moment ──────────────────────────────
     Am 21.09.2026 am echten Shop gemessen: eine Variante, die der Dienst
     gerade angelegt hat, weist der Warenkorb mit HTTP 422 ab („Das Produkt
     ... ist nicht verfuegbar") -- und zwar vier Versuche lang. Erst der fuenfte
     Versuch nach 5,3 Sekunden ging durch.

     Das erklaert zwei Beobachtungen, fuer die vorher keine Ursache gefunden
     wurde: dass die Versandzeile „manchmal ausblieb", und dass der Kauf einer
     noch nie bestellten Laenge mit einer Fehlermeldung endete.

     Deshalb: mehrmals versuchen, mit wachsender Pause, zusammen rund
     16 Sekunden, in nur sieben Anfragen. Laenger nicht -- dann steckt ein echter Fehler dahinter. */
  var WARTEN = [1200, 1800, 2400, 3000, 3600, 4200];

  function warte(ms) {
    return new Promise(function (f) { setTimeout(f, ms); });
  }

  /* Frueher hat ein Fehlschlag hier die Reparatur abgebrochen, NACHDEM die
     alte Versandzeile schon entfernt war -- der Warenkorb stand dann ohne
     Versand da. Mit einem 0-EUR-Versandprofil heisst das Versand geschenkt. */
  function zeileAnlegen(soll, nr) {
    var i = nr || 0;
    return post("/cart/add.js", { items: [soll] }).catch(function (e) {
      if (i >= WARTEN.length) throw e;
      return warte(WARTEN[i]).then(function () {
        return zeileAnlegen(soll, i + 1);
      });
    });
  }

  /* ── Die Versandzeile im Warenkorb festhalten ──────────────────────────────
     Shopify rendert fuer JEDE Zeile einen Mengenregler und einen
     Entfernen-Knopf -- auch fuer unsere Versandzeile. Beides gehoert dort
     nicht hin: die Menge ist immer 1, und geloescht wird sie ohnehin gleich
     wieder ergaenzt. Am 22.09.2026 ist mir beim Pruefen selbst passiert, was
     einem Kunden passieren kann: Menge 2 und damit 50,20 EUR statt 25,10.

     Die Bedienelemente werden nur ausgeblendet, nicht entfernt -- Dawns
     eigenes Warenkorb-Skript sucht die Felder und soll sie weiter finden. */
  var letzteAntwort = null;

  function unsereZeilen() {
    var alle = document.querySelectorAll(".cart-item");
    var meine = [], i;
    for (i = 0; i < alle.length; i++) {
      if (alle[i].querySelector('a[href*="/products/versand"]')) meine.push(alle[i]);
    }
    return meine;
  }

  function zeileFesthalten() {
    var zeilen = unsereZeilen(), i, j;
    for (i = 0; i < zeilen.length; i++) {
      var zeile = zeilen[i];

      /* Die Zeile soll nicht wie ein zweites Produkt dastehen, sondern wie
         ein Posten der Bestellung. Das Bild fliegt raus, die Zeile bekommt
         eine eigene Klasse (Aussehen in gw.css) und einen Satz, der sagt,
         wozu sie gehoert. Vorgabe Henry 22.09.2026: "mach das es kein
         einzelner punkt is oder wenigstens als zugehoerig angezeigt wird". */
      if (zeile.dataset.gwZugehoerig !== "1") {
        zeile.dataset.gwZugehoerig = "1";
        zeile.classList.add("gw-korb-zeile");
        var bild = zeile.querySelectorAll(
          ".cart-item__media img, .cart-item__image-container, .cart-item__media a, .cart-item__media svg");
        for (j = 0; j < bild.length; j++) bild[j].style.display = "none";

        var details = zeile.querySelector(".cart-item__details");
        if (details && !details.querySelector(".gw-korb-zugehoerig")) {
          var satz = document.createElement("p");
          satz.className = "gw-korb-zugehoerig";
          satz.textContent = "Gehört zu deiner Bestellung — einmal je Sendung, "
                           + "vom Rechner ermittelt.";
          details.appendChild(satz);
        }
      }

      var zelle = zeile.querySelector(".cart-item__quantity");
      if (!zelle || zelle.dataset.gwFest === "1") continue;
      zelle.dataset.gwFest = "1";
      var weg = zelle.querySelectorAll("quantity-popover, quantity-input, cart-remove-button, .quantity-popover-wrapper");
      for (j = 0; j < weg.length; j++) weg[j].style.display = "none";
      var text = document.createElement("p");
      text.className = "gw-korb-fest";
      text.textContent = "Wird automatisch berechnet";
      zelle.appendChild(text);
    }
  }

  /* Der Satz unter der Summe ist Dawns Standard und steht im Widerspruch zu
     dem, was daruebersteht: "Rabatte und Versand werden beim Checkout
     berechnet" -- obwohl der Versand als Zeile schon drin ist. Also richtig
     stellen, und zwar fallweise: bei Zuschnitten traegt unsere Zeile den
     ganzen Versand, bei Packs kommt Shopifys Pauschale an der Kasse dazu. */
  function summensatzRichtigstellen() {
    var note = document.querySelector(".tax-note");
    if (!note || !letzteAntwort) return;
    var gesamt = Number(letzteAntwort.preis);
    var unsere = Number(letzteAntwort.zuschlag);
    if (!(gesamt > 0)) return;                /* kein Versand im Spiel */
    if (note.dataset.gwStand === String(gesamt) + "/" + String(unsere)) return;
    note.dataset.gwStand = String(gesamt) + "/" + String(unsere);

    function eur(n) { return n.toFixed(2).replace(".", ",") + " \u20ac"; }
    var satz;
    if (!isFinite(unsere) || Math.abs(gesamt - unsere) < 0.005) {
      satz = "Inkl. Steuern und Versand. Rabatte werden beim Checkout "
           + "berechnet.";
    } else {
      satz = "Inkl. Steuern. Versand insgesamt " + eur(gesamt) + " \u2014 "
           + eur(unsere) + " stehen oben in der Liste, " + eur(gesamt - unsere)
           + " kommen an der Kasse dazu. Rabatte werden beim Checkout "
           + "berechnet.";
    }
    note.textContent = satz;
  }

  function anzeigeNachziehen() {
    zeileFesthalten();
    summensatzRichtigstellen();
  }

  /* Dawn baut die Warenkorbzeilen nach jeder Aenderung neu auf und wirft
     unsere Anpassungen dabei weg. Deshalb zusehen und erneut anwenden. */
  var letzteRunde = 0;

  function anzeigeBeobachten() {
    /* Auch die Warenkorb-Schublade: sie rendert ihre Zeilen selbst und
       ersetzt sie komplett. Henry am 22.09.2026: nach dem Loeschen des
       letzten Zuschnitts blieb die Versandzeile allein stehen. */
    var ziele = document.querySelectorAll(
      "#main-cart-items, cart-items, .cart__items, cart-drawer, #CartDrawer");
    for (var i = 0; i < ziele.length; i++) {
      (function (ziel) {
        if (ziel.dataset.gwBeobachtet === "1") return;
        ziel.dataset.gwBeobachtet = "1";
        var geplant = null;
        new MutationObserver(function () {
          if (geplant) return;
          geplant = setTimeout(function () {
            geplant = null;
            anzeigeNachziehen();
            /* Und nachrechnen: hat der Kunde gerade die letzte Position
               geloescht, muss die Versandzeile mit. Der fetch-Haken faengt
               das normalerweise ab -- aber wenn ein Aufruf daneben geht oder
               die Schublade ihre eigenen Wege nimmt, ist das hier das Netz.
               Hoechstens alle drei Sekunden, damit sich nichts aufschaukelt. */
            var jetzt = Date.now();
            if (jetzt - letzteRunde > 3000) {
              letzteRunde = jetzt;
              still();
            }
          }, 150);
        }).observe(ziel, { childList: true, subtree: true });
      }(ziele[i]));
    }
  }

  /* Zaehler fuer die Wiederholung, wenn der Warenkorb noch halb fertig ist. */
  var nochmal = 0;

  /* ── Kopfzeile nachziehen ────────────────────────────────────────────────
     Der Rechner und der Pack-Knopf legen ueber /cart/add.js hinein, also am
     Theme vorbei. Dawn merkt davon nichts: die Zahl am Warenkorb-Symbol und
     die Schublade bleiben stehen, bis die Seite neu laedt. Fuer den Kunden
     sieht es dann aus, als waere nichts passiert -- Henry am 22.09.2026:
     "ich muss immer Seite neu laden damits im Warenkorb is".

     Shopify rendert einzelne Abschnitte auf Anfrage; genau so macht Dawn es
     selbst. Wir holen den Abschnitt des Warenkorb-Symbols und tauschen ihn
     aus. Geht etwas schief, bleibt einfach die alte Anzeige stehen. */
  function kopfNachziehen() {
    var bubble = document.getElementById("cart-icon-bubble");
    var lade = document.querySelector("cart-drawer");
    var notiz = document.querySelector("cart-notification");
    var teile = [];
    if (bubble) teile.push("cart-icon-bubble");
    if (lade) teile.push("cart-drawer");
    if (notiz) teile.push("cart-notification");
    if (!teile.length) return Promise.resolve();

    /* Shopifys Abschnitts-Schnittstelle: mehrere Abschnitte in EINER Anfrage,
       als JSON. Genau so macht Dawn es selbst.

       Die Zahl allein reicht nicht -- Henry am 22.09.2026: "es wird zwar ne
       nummer am warenkorb angezeigt aber ohne neuladen nix drin". Die
       Schublade ist beim Seitenaufbau gerendert worden, damals war der
       Warenkorb leer, und sie bleibt es, bis jemand sie neu rendert. */
    return fetch("/?sections=" + teile.join(","), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;

        function tauschen(ziel, html, auswahl) {
          if (!ziel || !html) return;
          var hilf = document.createElement("div");
          hilf.innerHTML = html;
          /* Der Abschnitt kommt in einer Huelle
             <div id="shopify-section-…">. Das gesuchte Element steckt darin
             -- oder die Huelle selbst ist schon der Inhalt. */
          var neu = hilf.querySelector(auswahl)
                 || hilf.querySelector("#shopify-section-" + auswahl)
                 || hilf.firstElementChild;
          if (!neu) return;
          ziel.innerHTML = neu.innerHTML;
          /* NUR die Klasse "is-empty" angleichen, nicht die ganze
             Klassenliste. Der frisch gerenderte Abschnitt ist immer der
             GESCHLOSSENE Zustand -- wer seine Klassen komplett uebernimmt,
             loescht damit "active"/"animate" und die Schublade klappt mitten
             im Loeschen zu. Genau das ist passiert (Henry, 23.09.2026: "dann
             muss ich wieder auf die Tasche druecken um das naechste zu
             loeschen"). */
          if (neu.classList && neu.classList.contains("is-empty")) {
            ziel.classList.add("is-empty");
          } else {
            ziel.classList.remove("is-empty");
          }
        }

        if (bubble) tauschen(bubble, d["cart-icon-bubble"], "cart-icon-bubble");
        if (lade) {
          tauschen(lade, d["cart-drawer"], "cart-drawer");
          /* Dawn haengt den Schliessen-Klick an die Flaeche hinter der
             Schublade. Beim Austausch des Inhalts geht der Zuhoerer
             verloren -- also wieder anhaengen, genau wie Dawn es nach
             seinem eigenen Neuaufbau tut. Sonst laesst sich die Schublade
             nur noch ueber das Kreuz schliessen. */
          var flaeche = lade.querySelector("#CartDrawer-Overlay");
          if (flaeche && typeof lade.close === "function") {
            flaeche.addEventListener("click", lade.close.bind(lade));
          }
        }
        if (notiz) tauschen(notiz, d["cart-notification"], "cart-notification");
      })
      .catch(function () {});
  }

  var MERKER = "gwKorbGeprueft";
  var NACHRICHT = "gwKorbNachricht";

  function melde(text) {
    var ziel = document.querySelector("[data-gw-korb-hinweis]");
    if (!ziel) return;
    ziel.textContent = text;
    ziel.hidden = !text;
  }

  function nachricht_nachtragen() {
    var text = null;
    try {
      text = sessionStorage.getItem(NACHRICHT);
      sessionStorage.removeItem(NACHRICHT);
    } catch (e) { return; }
    if (text) melde(text);
  }

  /* Eine Runde: lesen, vergleichen, notfalls reparieren.
     Gibt true zurück, wenn etwas geändert wurde. */
  function pruefen() {
    var dienst = adresse();
    if (!dienst) return Promise.resolve(false);

    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (korb) {
        var zeilen = korb.items || [];

        /* Eine gerade angelegte Variante ist ein paar Sekunden lang nicht
           aufloesbar -- die Zeile kommt dann ohne Titel. Aus keinem Titel
           liest der Dienst keine Laenge, und wir wuerden die richtige
           Versandzeile wegraeumen. Also diese Runde auslassen und es gleich
           noch einmal versuchen. */
        var unfertig = zeilen.filter(function (z) {
          return !(z.title || z.product_title);
        });
        if (unfertig.length) {
          if (nochmal < 12) {
            nochmal += 1;
            return new Promise(function (f) { setTimeout(f, 900); })
              .then(function () { return pruefen(); });
          }
          return null;            /* aufgeben, aber nichts kaputt machen */
        }
        nochmal = 0;
        var versand = zeilen.filter(istVersand);
        var andere = zeilen.filter(function (z) { return !istVersand(z); });

        return post(dienst + "/zuschnitt/versandzeile",
                    { titel: andere.map(function (z) {
                        /* Menge zaehlt beim Gewicht: zwei 24-m-Packs sind
                           39 kg, ein einzelnes 19,7 kg. */
                        return { titel: titelVon(z), menge: z.quantity || 1 };
                      }) })
          .then(function (d) {
            if (!d.ok) throw new Error(d.fehler || "Dienst antwortet nicht");
            letzteAntwort = d;          /* fuer die Anzeige, siehe unten */
            var soll = d.zeile;

            /* Stimmt schon? Genau eine Zeile, richtige Variante, Menge 1. */
            if (soll && versand.length === 1
                && versand[0].id === soll.id
                && versand[0].quantity === 1) return null;
            if (!soll && versand.length === 0) return null;

            /* Reihenfolge: ERST die richtige Zeile hinein, DANN die alten
               heraus. Nicht umgekehrt -- scheitert das Hinzufuegen (siehe
               zeileAnlegen), stand der Warenkorb sonst ohne Versand da, und
               genau das ist mit einem 0-EUR-Profil der teure Fehler. So ist
               der schlechteste Fall zwei Zeilen fuer einen Augenblick: der
               Kunde zahlt kurz zu viel statt gar nichts, und die naechste
               Runde raeumt es auf.

               Nacheinander und nicht parallel — zwei gleichzeitige
               Schreibzugriffe auf denselben Warenkorb können sich
               gegenseitig überschreiben. */
            var kette = Promise.resolve();

            /* Liegt die RICHTIGE Variante schon drin und stimmt nur die Menge
               nicht, wird sie geradegezogen -- nicht neu angelegt.

               Warum das wichtig ist (Henry am 22.09.2026: "warum steht bei
               versand 19,60"): jedes Hinzufuegen legt eine Versandzeile dazu,
               und gleiche Zeilen verschmelzen zu EINER mit hoeherer Menge.
               Nach vier Kaeufen stand dort 4 x 4,90 = 19,60 EUR. Ein
               zusaetzliches Anlegen wuerde mit derselben Zeile verschmelzen
               (Menge 5), und das anschliessende Entfernen dieser Zeile
               loeschte dann ALLES -- der Warenkorb stuende ohne Versand da. */
            var passend = null, q;
            if (soll) {
              for (q = 0; q < versand.length; q++) {
                if (versand[q].id === soll.id) { passend = versand[q]; break; }
              }
            }

            if (passend) {
              if (passend.quantity !== 1) {
                kette = kette.then(function () {
                  return post("/cart/change.js", { id: passend.key, quantity: 1 });
                });
              }
            } else if (soll) {
              kette = kette.then(function () { return zeileAnlegen(soll); });
            }

            versand.forEach(function (z) {
              if (passend && z.key === passend.key) return;   /* die bleibt */
              kette = kette.then(function () {
                return post("/cart/change.js", { id: z.key, quantity: 0 });
              });
            });
            return kette.then(function () {
              /* Den Text zurückgeben statt anzeigen: wer den Abgleich
                 ausgelöst hat, entscheidet, wo er hingehört. Der Rechner hat
                 seine eigene Meldung, die Warenkorb-Seite trägt ihn über das
                 Neuladen. */
              return !versand.length
                    ? "Versand ergänzt: " + d.stufe + ", nach dem längsten Teil ("
                      + d.laengste + " mm)."
                    : !soll
                    ? "Versandzeile entfernt — es liegen keine Zuschnitte mehr "
                      + "im Warenkorb."
                    : "Versand angepasst auf „" + d.stufe + "“, nach dem "
                      + "längsten Teil (" + d.laengste + " mm).";
            });
          });
      })
      .catch(function (e) {
        /* Nicht schweigen, aber auch nicht den Warenkorb blockieren. */
        melde("Der Versand konnte nicht geprüft werden (" + e.message
              + "). Falls die Zeile fehlt oder nicht zur Länge passt, "
              + "schreib uns bitte kurz.");
        return null;
      });
  }

  /* Nach einer Reparatur muss die Seite die neuen Zeilen zeigen. Genau
     einmal neu laden — der Merker verhindert eine Schleife, falls der Dienst
     und diese Datei sich einmal uneinig sind. */
  function laufen() {
    nachricht_nachtragen();
    nochmal = 0;
    pruefen().then(function (text) {
      /* Erst jetzt steht die Antwort des Dienstes fest -- vorher weiss die
         Anzeige nicht, wie hoch der Versand insgesamt ist. */
      anzeigeNachziehen();
      if (!text) {
        try { sessionStorage.removeItem(MERKER); } catch (e) {}
        return;
      }
      var schon = false;
      try { schon = sessionStorage.getItem(MERKER) === "1"; } catch (e) {}
      if (schon) {
        /* Zweiter Anlauf hintereinander: dann sind Dienst und diese Datei
           uneinig, und ein weiteres Neuladen würde ewig so weitergehen. */
        melde("Der Versand im Warenkorb passt nicht zu den Längen. "
              + "Bitte schreib uns kurz, wir richten das von Hand.");
        return;
      }
      try {
        sessionStorage.setItem(MERKER, "1");
        sessionStorage.setItem(NACHRICHT, text);
      } catch (e) {}
      window.location.reload();
    });
  }

  /* Von aussen aufrufbar. Gibt einen Text zurück, wenn etwas geändert
     wurde, sonst null — der Aufrufer entscheidet, ob und wo er ihn zeigt. */
  window.GWKorb = { pruefen: pruefen, kopf: kopfNachziehen };

  /* Ueberall still reparieren, neu laden nur da, wo der Warenkorb sichtbar
     ist. Die Warenkorb-Seite erkennt man am Hinweisfeld des Abschnitts
     „GW · Warenkorb-Prüfung"; auf einer Rechnerseite würde ein Reload mitten
     in die Eingabe platzen. */
  function sichtbarerWarenkorb() {
    return !!document.querySelector("[data-gw-korb-hinweis]");
  }

  function still() {
    if (eigeneAenderung) return;
    eigeneAenderung = true;
    nochmal = 0;               /* jeder neue Anlauf faengt wieder bei 0 an */
    pruefen().then(function () {
      eigeneAenderung = false;
      anzeigeNachziehen();
      kopfNachziehen();
    }, function () {
      eigeneAenderung = false;
    });
  }

  /* Die Warenkorb-Schublade legt über fetch nach und rendert selbst; ein
     Reload würde sie zuklappen. Deshalb hängen wir uns an fetch und prüfen
     hinterher noch einmal, ohne Reload. So ist die Versandzeile da, bevor
     jemand in der Schublade auf „Auschecken" klickt — man muss nicht über
     die Warenkorb-Seite gehen. */
  function beobachten() {
    if (!window.fetch || window.fetch.__gwKorb) return;
    var echt = window.fetch;
    var neu = function (eingabe, optionen) {
      var pfad = typeof eingabe === "string"
        ? eingabe : (eingabe && eingabe.url) || "";
      var aendert = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(pfad);
      var ergebnis = echt.apply(this, arguments);
      if (aendert && !eigeneAenderung) {
        return ergebnis.then(function (antwort) {
          still();
          return antwort;
        });
      }
      return ergebnis;
    };
    neu.__gwKorb = true;
    window.fetch = neu;
  }

  function starten() {
    if (!adresse()) return;
    beobachten();
    anzeigeBeobachten();        /* die Schublade gibt es auf jeder Seite */
    anzeigeNachziehen();        /* sofort, damit nichts aufblitzt */
    if (sichtbarerWarenkorb()) {
      laufen();                 /* mit Reload, damit die Zeile erscheint */
    } else {
      still();                  /* lautlos, damit die Kasse stimmt */
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", starten);
  } else {
    starten();
  }
}());
